import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import { Observable } from "rxjs/Observable";

import 'rxjs/add/operator/map';
import 'rxjs/add/operator/toPromise';
import 'rxjs/add/operator/catch';

import * as globalConst from './../../../constants';

@Injectable()
export class OrderRequisitionsService {

  private apiUrl = globalConst.baseAPI;  // URL para web api

  constructor(private http: Http) { }


	getRequisitionDetail(id) {
		return this.http
			.get(this.apiUrl + "order/v1/getbysolicitante/" + id, JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json())
			.catch(e => {
				if (e.status === 401) {
					return Observable.throw('Unauthorized');
				}
			});
  }
  
  getRequisitionFlow(id) {
		return this.http
			.get(this.apiUrl + "order/v1/getbyfluxosolicitante/" + id, JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json())
			.catch(e => {
				if (e.status === 401) {
					return Observable.throw('Unauthorized');
				}
			});
  }

  approveOrders(id, comentario) {
    const objToSend = {
			SolicitanteFluxoID: id,
			Comentario: comentario
    }
		return this.http
			.post(this.apiUrl + "order/v1/postflowapproval/", objToSend, JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json())
			.catch(e => {
				if (e.status === 401) {
					return Observable.throw('Unauthorized');
				}
			});
  }

  reproveOrders(id, comentario) {
		const objToSend = {
	  SolicitanteFluxoID: id,
	  Comentario: comentario
    }
		return this.http
			.post(this.apiUrl + "order/v1/postflowblock/", objToSend, JSON.parse(localStorage.getItem('yara.connectionHeader')))
			.map((res: Response) => res.json())
			.catch(e => {
				if (e.status === 401) {
					return Observable.throw('Unauthorized');
				}
			});
  }
  	
}





// WEBPACK FOOTER //
// ./src/app/order-requisitions/services/order-requisitions.service.ts